import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhaseThree = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 273,
	height: 182,
	viewBox: "0 0 273 182",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "bg",
			d: "M48 97.275C48 107.89 56.9265 133.239 76.2357 144.389C95.9518 155.774 112.482 146.248 135.732 146.623C153.294 146.907 164.116 151.943 180.708 146.623C204.185 139.097 229.656 126.194 224.272 103.793C220.527 88.2144 202.694 88.4672 191.599 76.2322C180.531 64.0268 181.718 51.4259 168.002 41.7814C138.311 20.9044 102.101 36.547 74.4206 59.6585C60.3555 71.4019 48 86.6604 48 97.275Z",
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 143.896,
			cy: 66.0775,
			rx: 19.8934,
			ry: 19.8362,
			stroke: "#CAD0E1",
			strokeWidth: .489763,
			strokeLinecap: "round",
			strokeDasharray: "1.96 2.94"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 33.1556,
			cy: 32.0431,
			rx: 33.1556,
			ry: 32.0431,
			transform: "matrix(-1 0 0 1 133.184 77.2672)",
			stroke: "#CAD0E1",
			strokeWidth: .489763,
			strokeLinecap: "round",
			strokeDasharray: "1.96 2.94"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 137.105,
			cy: 93.751,
			rx: 15.0709,
			ry: 15.0276,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 109.336,
			y1: 51.8173,
			x2: 109.336,
			y2: 53.0176,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 109.336,
			y1: 55.2324,
			x2: 109.336,
			y2: 56.4327,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 107.15,
			y1: 54.2529,
			x2: 108.356,
			y2: 54.2529,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.21,
			y1: 54.2529,
			x2: 111.417,
			y2: 54.2529,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 189.039,
			cy: 114.142,
			rx: 13.5173,
			ry: 13.4784,
			stroke: "#CAD0E1",
			strokeWidth: .489763,
			strokeLinecap: "round",
			strokeDasharray: "1.96 2.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.498 60.0398C91.498 61.1943 90.5591 62.1315 89.3995 62.1315C88.2399 62.1315 87.301 61.1943 87.301 60.0398C87.301 58.8852 88.2399 57.948 89.3995 57.948C90.5591 57.948 91.498 58.8852 91.498 60.0398Z",
			stroke: "#CAD0E1",
			strokeWidth: .489763
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.443 46.4499C163.443 47.1967 162.835 47.8033 162.085 47.8033C161.334 47.8033 160.727 47.1967 160.727 46.4499C160.727 45.7031 161.334 45.0964 162.085 45.0964C162.835 45.0964 163.443 45.7031 163.443 46.4499Z",
			stroke: "#CAD0E1",
			strokeWidth: .489763
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M212.653 103.697C212.653 104.444 212.046 105.051 211.295 105.051C210.545 105.051 209.937 104.444 209.937 103.697C209.937 102.95 210.545 102.344 211.295 102.344C212.046 102.344 212.653 102.95 212.653 103.697Z",
			stroke: "#CAD0E1",
			strokeWidth: .489763
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.996 133.254C103.996 134.641 102.953 135.735 101.702 135.735C100.451 135.735 99.4084 134.641 99.4084 133.254C99.4084 131.867 100.451 130.773 101.702 130.773C102.953 130.773 103.996 131.867 103.996 133.254Z",
			stroke: "#CAD0E1",
			strokeWidth: .489763
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.411 71.4268C177.153 91.7249 163.64 107.576 155.165 112.964L155.165 114.397C178.253 98.0271 170.282 78.9295 163.411 71.4268Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.552 70.1991C159.46 68.2894 152.726 63.7741 150.527 60.9913C153.906 61.1277 161.04 63.1603 162.552 70.1991Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.472 77.5654C163.64 77.9746 159.013 77.6063 155.165 72.8591C157.424 71.9725 162.647 71.6724 165.472 77.5654Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M167.877 89.4332C166.045 88.6829 162.209 85.8319 161.521 80.43C164.098 80.4982 168.977 82.3943 167.877 89.4332Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.472 100.073C164.041 99.1866 161.35 95.8172 162.037 89.4332C164.499 90.1834 168.633 93.3618 165.472 100.073Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.914 109.69C157.284 107.576 156.574 102.447 158.773 98.8456C160.892 100.141 163.686 104.125 157.914 109.69Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.521 110.918C162.838 108.872 166.984 104.452 173.031 103.143C171.714 106.621 167.568 113.046 161.521 110.918Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.908 100.073C169.881 97.2086 172.756 91.1929 176.466 90.047C176.861 93.3891 175.902 100.073 168.908 100.073Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.313 88.8193C171.141 85.2726 171.519 77.8518 174.405 76.5423C176.008 79.5433 177.634 86.2002 171.313 88.8193Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.908 76.5423C168.908 76.5423 164.957 71.8361 167.19 64.2652C169.595 66.9525 173.306 73.1701 168.908 76.5423Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.943 95.1411C149.943 95.1411 151.745 94.8513 152.512 94.0863C153.28 93.3213 153.57 91.5247 153.57 91.5247C153.57 91.5247 153.861 93.3213 154.628 94.0863C155.395 94.8513 157.197 95.1411 157.197 95.1411C157.197 95.1411 155.395 95.4309 154.628 96.1959C153.861 96.9609 153.57 98.7576 153.57 98.7576C153.57 98.7576 153.28 96.9609 152.512 96.1959C151.745 95.4309 149.943 95.1411 149.943 95.1411Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.683 81.3923C183.683 81.3923 185.485 81.1025 186.252 80.3375C187.019 79.5725 187.31 77.7759 187.31 77.7759C187.31 77.7759 187.6 79.5725 188.368 80.3375C189.135 81.1025 190.937 81.3923 190.937 81.3923C190.937 81.3923 189.135 81.6821 188.368 82.4471C187.6 83.2121 187.31 85.0088 187.31 85.0088C187.31 85.0088 187.019 83.2121 186.252 82.4471C185.485 81.6821 183.683 81.3923 183.683 81.3923Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.211 91.3636C188.211 91.3636 190.43 91.0068 191.375 90.0649C192.319 89.123 192.677 86.9109 192.677 86.9109C192.677 86.9109 193.035 89.123 193.979 90.0649C194.924 91.0068 197.143 91.3636 197.143 91.3636C197.143 91.3636 194.924 91.7205 193.979 92.6624C193.035 93.6042 192.677 95.8163 192.677 95.8163C192.677 95.8163 192.319 93.6042 191.375 92.6624C190.43 91.7205 188.211 91.3636 188.211 91.3636Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.284 137.707C127.284 137.707 129.502 137.35 130.447 136.408C131.392 135.466 131.749 133.254 131.749 133.254C131.749 133.254 132.107 135.466 133.052 136.408C133.997 137.35 136.215 137.707 136.215 137.707C136.215 137.707 133.997 138.064 133.052 139.005C132.107 139.947 131.749 142.159 131.749 142.159C131.749 142.159 131.392 139.947 130.447 139.005C129.502 138.064 127.284 137.707 127.284 137.707Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72.1712,
			y1: 73.3808,
			x2: 72.1712,
			y2: 75.3025,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72.1712,
			y1: 77.2494,
			x2: 72.1712,
			y2: 79.1711,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 69.2616,
			y1: 76.2699,
			x2: 71.1917,
			y2: 76.2699,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 73.1409,
			y1: 76.2699,
			x2: 75.071,
			y2: 76.2699,
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 9.911,
			y2: -.489763,
			transform: "matrix(-0.704154 0.710047 -0.71207 -0.702108 68.5876 78.5765)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 16.8837,
			y2: -.489763,
			transform: "matrix(-0.70575 0.708461 -0.710489 -0.703708 68.0725 82.4532)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 2.4115,
			y2: -.489763,
			transform: "matrix(2.7095e-08 1 1 -3.13413e-08 184.74 110.328)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 2.4115,
			y2: -.489763,
			transform: "matrix(2.71731e-08 1 1 -3.12512e-08 184.74 114.196)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 2.21559,
			y2: -.489763,
			transform: "matrix(-1 -1.45286e-08 -1.46124e-08 1 187.445 114.196)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 2.21559,
			y2: -.489763,
			transform: "matrix(-1 -1.56256e-08 -1.35866e-08 1 183.838 114.196)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 9.55558,
			y2: -.489763,
			transform: "matrix(0.677883 0.73517 0.686063 -0.727543 187.33 116.608)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .489763,
			y1: -.489763,
			x2: 16.2872,
			y2: -.489763,
			transform: "matrix(0.67953 0.733648 0.684427 -0.729081 188.095 119.89)",
			stroke: "#CAD0E1",
			strokeWidth: .979526,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_1075_63)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48.9651,
				height: 30.8405,
				rx: 3,
				transform: "matrix(0.988571 -0.150759 0.151609 0.98844 77.0749 94.8217)",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.3719 96.7581C77.2079 95.6886 77.942 94.6894 79.0116 94.5263L123.544 87.7351C124.613 87.572 125.613 88.3067 125.777 89.3761L126.552 94.4256L78.1464 101.808L77.3719 96.7581Z",
			fill: "#D9DDE9"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .734644,
			y1: -.734644,
			x2: 18.5937,
			y2: -.734644,
			transform: "matrix(0.988571 -0.150759 0.151609 0.98844 105.259 112.838)",
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.46929,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .734644,
			y1: -.734644,
			x2: 18.5937,
			y2: -.734644,
			transform: "matrix(0.988571 -0.150759 0.151609 0.98844 104.512 107.969)",
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.46929,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .734644,
			y1: -.734644,
			x2: 18.5937,
			y2: -.734644,
			transform: "matrix(0.988571 -0.150759 0.151609 0.98844 103.765 103.1)",
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.46929,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .734644,
			y1: -.734644,
			x2: 15.3723,
			y2: -.734644,
			transform: "matrix(0.988571 -0.150759 0.151609 0.98844 106.006 117.707)",
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.46929,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .734644,
			y1: -.734644,
			x2: 13.4395,
			y2: -.734644,
			transform: "matrix(0.988571 -0.150759 0.151609 0.98844 80.3044 98.8787)",
			stroke: "white",
			strokeWidth: 1.46929,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 17.3955,
			height: 17.3478,
			rx: 1.125,
			transform: "matrix(0.988571 -0.150759 0.151609 0.98844 81.5883 104.722)",
			fill: "#D9DDE9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.9915 116.003C94.1354 115.603 93.4884 115.125 93.3034 113.919C93.1924 113.195 93.695 112.638 93.7958 111.988C93.8965 111.338 93.8971 110.586 93.9094 110.037C93.9216 109.489 93.9273 109.276 93.8912 108.699C93.8449 107.979 93.1083 106.214 90.6737 106.586C88.2398 106.957 88.0644 108.861 88.2374 109.561C88.3759 110.123 88.4453 110.324 88.6212 110.844C88.7972 111.364 89.022 112.081 89.3129 112.672C89.6038 113.262 90.2512 113.644 90.3623 114.367C90.5473 115.574 90.0731 116.222 88.4217 117.157C86.7642 118.095 85.7228 118.928 85.7943 119.394L86.1291 121.577L99.5043 119.538L99.1695 117.355C99.0981 116.889 97.8536 116.404 95.9915 116.003Z",
			fill: "#B3BAD3"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_1075_63)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M151.756 97.9841C151.354 101.309 148.326 103.679 144.991 103.279L105.518 98.5357C102.183 98.1352 99.8061 95.1155 100.208 91.7908L102.67 71.4159C103.072 68.0912 106.1 65.7208 109.435 66.1219L148.908 70.8643C152.243 71.2642 154.62 74.2845 154.218 77.6092L151.756 97.9841Z",
					fill: "#E2E6F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.279 92.6276L116.092 89.0007L116.149 88.5379L146.335 92.1643L146.279 92.6276Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M145.943 95.4064L115.756 91.7795L115.813 91.3167L145.999 94.9431L145.943 95.4064Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.241 93.079L116.476 93.5473C116.538 93.6689 116.588 93.7806 116.642 93.9011L116.654 93.9022C116.736 93.7895 116.815 93.6934 116.895 93.5934L117.231 93.1978L117.629 93.2462L116.821 94.1383L117.406 95.266L116.987 95.216L116.745 94.726C116.68 94.5994 116.627 94.4794 116.57 94.3494L116.562 94.3483C116.48 94.4611 116.396 94.5616 116.306 94.6727L115.959 95.0921L115.554 95.0438L116.397 94.1L115.831 93.0295L116.241 93.079Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118.176 93.3118L118.412 93.78C118.474 93.9017 118.523 94.0134 118.577 94.1333L118.589 94.135C118.671 94.0222 118.75 93.9256 118.83 93.8261L119.166 93.4306L119.564 93.4784L118.756 94.3711L119.341 95.4988L118.923 95.4482L118.68 94.9583C118.616 94.8316 118.562 94.7116 118.506 94.5816L118.497 94.5811C118.416 94.6939 118.331 94.7938 118.242 94.9049L117.894 95.3249L117.489 95.276L118.332 94.3328L117.766 93.2623L118.176 93.3118Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M120.11 93.5441L120.347 94.013C120.409 94.1341 120.459 94.2463 120.512 94.3657L120.524 94.3679C120.606 94.2546 120.685 94.1579 120.766 94.0591L121.102 93.6635L121.499 93.7113L120.691 94.6035L121.276 95.7317L120.858 95.6811L120.616 95.1912C120.551 95.0645 120.497 94.9445 120.441 94.8145L120.432 94.814C120.351 94.9262 120.266 95.0268 120.177 95.1379L119.829 95.5573L119.424 95.5084L120.267 94.5651L119.701 93.4947L120.11 93.5441Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M122.046 93.7766L122.282 94.2449C122.344 94.3666 122.394 94.4783 122.447 94.5982L122.459 94.5999C122.541 94.4877 122.62 94.391 122.701 94.291L123.037 93.8955L123.434 93.9433L122.627 94.836L123.212 95.9642L122.793 95.9137L122.551 95.4232C122.486 95.2971 122.433 95.1765 122.376 95.0471L122.368 95.046C122.286 95.1587 122.202 95.2587 122.112 95.3704L121.765 95.7898L121.359 95.7409L122.202 94.7977L121.637 93.7272L122.046 93.7766Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M123.981 94.0088L124.217 94.4771C124.279 94.5988 124.329 94.7104 124.382 94.831L124.394 94.8326C124.476 94.7199 124.556 94.6232 124.636 94.5238L124.972 94.1283L125.369 94.1755L124.561 95.0682L125.146 96.1964L124.729 96.1464L124.486 95.6559C124.421 95.5292 124.368 95.4093 124.311 95.2798L124.302 95.2787C124.222 95.3909 124.137 95.4909 124.047 95.6031L123.7 96.022L123.294 95.9731L124.137 95.0304L123.571 93.9594L123.981 94.0088Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M125.916 94.2417L126.152 94.71C126.214 94.8316 126.264 94.9433 126.318 95.0638L126.33 95.0649C126.412 94.9527 126.49 94.8561 126.571 94.7561L126.907 94.3606L127.304 94.4083L126.496 95.3005L127.081 96.4287L126.663 96.3787L126.421 95.8882C126.356 95.7621 126.303 95.6416 126.246 95.5121L126.238 95.511C126.156 95.6238 126.072 95.7238 125.982 95.8354L125.635 96.2548L125.23 96.206L126.073 95.2633L125.507 94.1922L125.916 94.2417Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M128.417 95.3081L128.384 95.5781L127.351 95.4548L127.384 95.1832L128.417 95.3081Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.11 94.6252L129.346 95.0935C129.408 95.2151 129.457 95.3268 129.511 95.4473L129.523 95.4484C129.605 95.3362 129.684 95.2396 129.764 95.1401L130.1 94.744L130.498 94.7918L129.69 95.6845L130.275 96.8127L129.857 96.7622L129.614 96.2717C129.55 96.1456 129.496 96.025 129.439 95.8956L129.431 95.8945C129.35 96.0073 129.266 96.1073 129.175 96.2189L128.828 96.6383L128.423 96.5894L129.266 95.6467L128.699 94.5757L129.11 94.6252Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.044 94.8579L131.28 95.3262C131.342 95.4478 131.392 95.5595 131.446 95.68L131.458 95.6812C131.54 95.5684 131.619 95.4723 131.699 95.3723L132.035 94.9768L132.433 95.0245L131.625 95.9167L132.21 97.0449L131.792 96.9949L131.55 96.5044C131.484 96.3783 131.431 96.2578 131.375 96.1283L131.366 96.1272C131.285 96.24 131.2 96.34 131.111 96.4516L130.763 96.871L130.358 96.8222L131.201 95.8795L130.635 94.8085L131.044 94.8579Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.98 95.0901L133.216 95.5584C133.277 95.6801 133.328 95.7917 133.381 95.9123L133.393 95.9134C133.475 95.8012 133.554 95.7045 133.634 95.6051L133.971 95.209L134.368 95.2573L133.56 96.1495L134.145 97.2777L133.727 97.2272L133.485 96.7372C133.419 96.6105 133.367 96.49 133.31 96.3606L133.301 96.3595C133.22 96.4728 133.136 96.5722 133.046 96.6839L132.698 97.1033L132.293 97.055L133.136 96.1117L132.57 95.0412L132.98 95.0901Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M134.915 95.3223L135.151 95.7912C135.213 95.9128 135.263 96.0245 135.316 96.145L135.328 96.1461C135.41 96.0334 135.489 95.9372 135.57 95.8373L135.906 95.4417L136.303 95.4901L135.495 96.3822L136.08 97.5099L135.662 97.4599L135.42 96.9699C135.355 96.8433 135.301 96.7227 135.245 96.5933L135.236 96.5922C135.155 96.705 135.07 96.8055 134.981 96.9166L134.634 97.336L134.228 97.2877L135.071 96.3439L134.506 95.2734L134.915 95.3223Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.85 95.5556L137.086 96.0239C137.148 96.1456 137.198 96.2573 137.251 96.3772L137.264 96.3789C137.345 96.2661 137.424 96.1695 137.505 96.07L137.841 95.6745L138.238 95.7223L137.43 96.615L138.015 97.7427L137.597 97.6921L137.355 97.2022C137.29 97.0755 137.236 96.9555 137.18 96.8255L137.171 96.825C137.09 96.9377 137.006 97.0377 136.916 97.1488L136.568 97.5688L136.163 97.5199L137.006 96.5767L136.44 95.5062L136.85 95.5556Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M150.196 79.7098C149.963 81.628 148.217 82.9956 146.293 82.764L126.788 80.4208C124.865 80.1898 123.493 78.4477 123.725 76.5295C123.956 74.6108 125.704 73.2437 127.628 73.4748L147.132 75.8185C149.056 76.0496 150.428 77.7916 150.196 79.7098Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143.274 82.4008L141.417 82.178L142.256 75.2314L144.114 75.4547L143.274 82.4008Z",
					fill: "#031A6B",
					fillOpacity: .06
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M140.024 82.011L137.237 81.676L138.076 74.7305L140.863 75.0649L140.024 82.011Z",
					fill: "#031A6B",
					fillOpacity: .06
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_1075_63)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M160.486 101.052C160.486 111.762 151.778 120.453 141.024 120.453C130.271 120.453 121.562 111.762 121.562 101.052C121.562 90.3419 130.271 81.6511 141.024 81.6511C151.778 81.6511 160.486 90.3419 160.486 101.052Z",
					fill: "#B5D8D4",
					fillOpacity: .75,
					stroke: "#4EA699",
					strokeWidth: 3.42834
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 9.12168,
					height: 26.9504,
					rx: 4.56084,
					transform: "matrix(0.708123 -0.706089 0.708123 0.706089 151.82 122.812)",
					fill: "#4EA699"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.825 133.838L165.835 136.803C169.37 140.284 175.25 136.869 173.956 132.086V132.086L174.068 132.195C175.882 133.959 175.9 136.86 174.108 138.646V138.646C172.337 140.412 169.467 140.417 167.689 138.657L162.825 133.838Z",
					fill: "#4B978C"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 3.225,
					height: 6.15682,
					rx: 1.6125,
					transform: "matrix(0.708123 -0.706089 -0.708123 -0.706089 155.349 122.167)",
					fill: "#4EA699"
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: .489763,
					y1: -.489763,
					x2: 10.0648,
					y2: -.489763,
					transform: "matrix(0.708123 0.706089 -0.708123 0.706089 160.955 121.753)",
					stroke: "white",
					strokeWidth: .979526,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: .489763,
					y1: -.489763,
					x2: 3.61478,
					y2: -.489763,
					transform: "matrix(0.708123 0.706089 -0.708123 0.706089 169.259 130.034)",
					stroke: "white",
					strokeWidth: .979526,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.07 87.7227C151.239 88.9714 153.065 90.7342 154.388 92.8551C155.711 94.9759 156.488 97.3892 156.652 99.8813C156.816 102.373 156.361 104.867 155.327 107.142C154.294 109.417 152.713 111.402 150.726 112.923C148.739 114.443 146.407 115.451 143.936 115.858C141.464 116.265 138.931 116.058 136.559 115.255C134.187 114.452 132.051 113.079 130.339 111.256C128.627 109.433 127.392 107.217 126.743 104.805C127.257 106.715 129.713 108.552 131.068 109.995C132.717 110.945 134.619 111.754 136.497 112.39C138.375 113.025 141.462 113.06 143.419 112.738C145.375 112.415 147.222 111.617 148.795 110.413C150.368 109.21 151.851 107.567 152.669 105.766C153.488 103.965 154.045 100.568 153.916 98.5945C153.786 96.6215 153.716 94.1531 152.669 92.474C151.622 90.7949 150.787 88.7113 149.07 87.7227Z",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 6.13433,
			cy: 4.21847,
			rx: 6.13433,
			ry: 4.21847,
			transform: "matrix(0.998905 -0.0467818 0.0470513 0.998892 133.82 85.8804)",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 1.62555,
			cy: 1.6209,
			rx: 1.62555,
			ry: 1.6209,
			transform: "matrix(0.998905 -0.0467818 0.0470513 0.998892 129.167 90.9425)",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_1075_63",
				x: 75.5356,
				y: 86.8778,
				width: 56.1598,
				height: 40.9489,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .979526 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .979526 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1075_63"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1075_63",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_1075_63",
				x: 98.2045,
				y: 66.0776,
				width: 58.017,
				height: 41.1632,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.95905 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .979526 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1075_63"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1075_63",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_1075_63",
				x: 117.889,
				y: 79.9369,
				width: 59.5415,
				height: 63.9552,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.95905 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .979526 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.792157 0 0 0 0 0.815686 0 0 0 0 0.882353 0 0 0 0.5 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1075_63"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1075_63",
						result: "shape"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgPhaseThree);
export { ForwardRef as ReactComponent };
